module.exports = __webpack_public_path__ + "img/4.44d866c1.png";